import React from 'react';

import { Ride } from '../../types/ride';

interface RideTypeProps {
  ride: Ride;
  withSpaceReplace?: boolean;
}

const getRideType = ({ ride, withSpaceReplace }: RideTypeProps) => {
  const { type } = ride;

  if (!type) {
    return 'Lyft';
  }

  if (withSpaceReplace) {
    return type.replaceAll(' ', '');
  }

  return type;
};
export const RideType: React.FC<RideTypeProps> = React.memo(function ({
  ride,
  withSpaceReplace = true,
}) {
  return <div>{getRideType({ ride, withSpaceReplace })}</div>;
});
